<div class="spinner-container">
  <span *ngIf="!loading">{{ value }}%</span>
  <div *ngIf="loading" class="loading-spinner-wrapper" >
    <mat-spinner 
    [diameter]="80"
    [strokeWidth]="5"
    ></mat-spinner>
  </div>

  <mat-progress-spinner
    *ngIf="!loading"
    class="spinner-progress"
    [mode]="'determinate'"
    [value]="value"
    [diameter]="diameter"
    [strokeWidth]="5"
  ></mat-progress-spinner>

  <mat-progress-spinner
    *ngIf="!loading"
    class="spinner-bg"
    [mode]="'determinate'"
    [value]="100"
    [diameter]="diameter"
    [strokeWidth]="5"
  ></mat-progress-spinner>
</div>
